import React from "react";
import Link from "next/link";
import Image from "../../components/CustomImage";
import { Button, Card, CardBody, CardFooter } from "reactstrap";
import { getImageUrl } from "../../services/image";
import { useRouter } from "next/router";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CardPost = function CardPost(_ref) {
  var camper = _ref.camper,
      pickupLocation = _ref.pickupLocation,
      dropOffLocation = _ref.dropOffLocation,
      pickupDate = _ref.pickupDate,
      dropOffDate = _ref.dropOffDate;
  var router = useRouter();
  return /*#__PURE__*/_jsxs(Card, {
    onClick: function onClick() {
      return router.push({
        pathname: "/camper/type/".concat(camper.seoId),
        query: {
          ophaallocatie: pickupLocation,
          afleverlocatie: dropOffLocation,
          ophaaldatum: pickupDate,
          afleverdatum: dropOffDate
        }
      });
    },
    className: "border-0 h-100 shadow camper-card",
    children: [/*#__PURE__*/_jsx(Image, {
      src: getImageUrl(camper.thumbnail),
      alt: "...",
      width: 1080,
      height: 720,
      layout: "intrinsic",
      className: "img-fluid card-img-top",
      sizes: "(max-width:576px) 100vw, 350px"
    }), /*#__PURE__*/_jsxs(CardBody, {
      children: [/*#__PURE__*/_jsxs("span", {
        className: "text-uppercase text-primary text-sm letter-spacing-2",
        children: [/*#__PURE__*/_jsx("strong", {
          children: camper.type
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("small", {
          children: camper.shortDescription
        })]
      }), /*#__PURE__*/_jsx("h5", {
        className: "my-2",
        children: /*#__PURE__*/_jsxs("span", {
          className: "text-dark",
          children: ["\u20AC ", camper.dayRate, " ", /*#__PURE__*/_jsx("small", {
            children: "per dag"
          })]
        })
      }), /*#__PURE__*/_jsx("h6", {
        className: "my-4",
        children: "Kenmerken"
      }), camper.features.map(function (feature) {
        return /*#__PURE__*/_jsxs("span", {
          className: "text-sm",
          children: [feature, /*#__PURE__*/_jsx("hr", {
            className: "m-2"
          })]
        }, feature);
      })]
    }), /*#__PURE__*/_jsx(CardFooter, {
      className: "bg-white",
      children: /*#__PURE__*/_jsx(Button, {
        block: true,
        color: "primary",
        children: "Bekijk camper"
      })
    })]
  });
};

export default CardPost;